// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AuthPage from './pages/AuthPage';
import AccountPage from './pages/AccountPage';
import Header from './components/Header';
import AdminRoute from './components/AdminRoute';
import AdminAccountPage from './pages/AdminAccountPage';
import ProductDetailPage from './pages/ProductDetailPage';
import HomePage from './pages/HomePage';

function App() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  return (
    <Router>
      <Header user={user} setUser={setUser} />
      <Routes>
        <Route path="/auth" element={<AuthPage setUser={setUser} />} />
        <Route path="/account" element={user ? <AccountPage user={user} /> : <AuthPage setUser={setUser} />} />
        <Route path="/admin-account" element={<AdminRoute><AdminAccountPage /></AdminRoute>} />
        <Route path="/products/:id" element={<ProductDetailPage />} />
        <Route path='/' element={<HomePage/>} />
      </Routes>
    </Router>
  );
}

export default App;
